module.exports = __webpack_public_path__ + "static/media/14UNEP15.b691ac4e.jpg";